import { render } from "./SelectQueryBuilderModal.vue?vue&type=template&id=18fb60a1"
import script from "./SelectQueryBuilderModal.vue?vue&type=script&lang=js"
export * from "./SelectQueryBuilderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__